import { isEmpty } from 'lodash'
import { bulletSection } from '../helper'

export default [
  {
    generate({ answers, parameters }) {
      const textPieces = []

      if (['diariamente', 'semanalmente'].includes(answers['7'])) {
        textPieces.push(`Falta de ar, sibilância, tosse ${answers['7']}`)
      }

      if (!isEmpty(answers['8']) && !['0', 'sem-informacao'].includes(answers['8'])) {
        textPieces.push(
          `${answers['8'].replace('-', ' a ').replace('+', ' ou mais')} despertares noturnos na última semana`,
        )
      }
      if(!isEmpty(answers['18']) && ['0', '1'].includes(answers['18'])){
        textPieces.push(`${answers['18']} exacerbação grave com necessidade de corticoide sistêmico no último ano`)
      } else if (!isEmpty(answers['18']) && !['sem-informacao'].includes(answers['18'])) {
        textPieces.push(
          `${answers['18'].replace(
            '+',
            ' ou mais',
          )} exacerbações graves com necessidade de corticoide sistêmico no último ano`,
        )
      }

      if (!isEmpty(answers['9']) && !['0', 'sem-informacao'].includes(answers['9'])) {
        textPieces.push(
          `Precisou buscar o pronto atendimento ou foi hospitalizado ${answers['9'].replace(
            '+',
            ' ou mais',
          )} vezes no último ano, por exacerbação`,
        )
      }

      if (parameters['act']?.score <= 19) {
        textPieces.push(`ACT (Asthma Control Test) com pontuação indicando controle inadequado da asma`)
      } else if (parameters['gina']?.label === 'Asma não controlada') {
        textPieces.push(`GINA indicando controle inadequado da asma`)
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Apresenta:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
